import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOEditarGrupo = async (grupo) => {
    try {
        if (grupo.id) {
            const resp = await axios.put(
                `${API_URL}/administrar/gruposPermisos/${grupo.id}`,
                grupo,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/administrar/gruposPermisos`,
            grupo,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectGrupos = async () => {
    try {
        const resp = await axios.get(
            `${API_URL}/administrar/gruposPermisos/select`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarGrupo = async (id_grupo) => {
    try {
        const resp = await axios.delete(
            `${API_URL}/administrar/gruposPermisos/${id_grupo}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarGrupo = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/administrar/gruposPermisos/activar/${data.id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
